"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TrayButtonWrapper;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _componentUtilities = require("@ux/component-utilities");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _chevronDown = _interopRequireDefault(require("@ux/icon/chevron-down"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Get a width for a given node
 *
 * @param {Element} element the element to measure
 * @returns {Number} the width of {element}
 * @api private
 */
function getWidth(element) {
  if (!element) {
    return 0;
  }
  const style = window.getComputedStyle(element) || {
    width: void 0
  };
  return parseFloat(style.width) || 0;
}
const breakpoints = ['mobile', 'phablet', 'tablet', 'desktop', 'large'];
/**
 * Tray button component.
 *
 * Tray buttons are the anchor for the tray menu, or what element is used to
 * toggle the menu open or closed.
 *
 * @class TrayButton
 * @public
 */
class TrayButton extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      trayToggleWidth: 0,
      caretMarginLeft: 0
    };
    this.trayToggleWrapper = /*#__PURE__*/_react.default.createRef();
  }

  /**
   * Render the component.
   *
   * @returns {React.ReactElement} Button.
   * @api public
   */
  render() {
    const props = this.props;
    const {
      className,
      ariaLabel,
      onClick,
      children,
      traySpanClass,
      dataAttrs
    } = props;
    let caretNode = null;
    if (props.showOpenCaret) {
      caretNode = /*#__PURE__*/_react.default.createElement("span", {
        className: "tray-toggle-caret",
        style: {
          marginLeft: this.state.caretMarginLeft + 'px'
        }
      });
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "tray-toggle-wrapper",
      ref: this.trayToggleWrapper
    }, /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
      "aria-label": ariaLabel,
      onClick: onClick,
      className: (0, _classnames.default)(className, 'tray-toggle')
    }, dataAttrs, {
      "aria-expanded": props['aria-expanded'],
      "aria-haspopup": true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: traySpanClass
    }, children), /*#__PURE__*/_react.default.createElement("span", {
      className: props.isOpen ? 'chevron-down open' : 'chevron-down'
    }, /*#__PURE__*/_react.default.createElement(_chevronDown.default, {
      width: 20,
      height: 20,
      className: "tray-toggle-chevron"
    }))), caretNode);
  }

  /**
   * Calculate the margin for placing the caret
   *
   * @api private
   */
  componentDidMount() {
    if (this.props.showOpenCaret) {
      this.calcCaretMargin();
    }
  }

  /**
   * Calculate the margin for placing the caret
   *
   * @param {Object} previousProps the props before the component updated
   * @param {Object} previousState the state before the component updated
   * @api private
   */
  componentDidUpdate(previousProps, previousState) {
    if ((previousState.breakpoint !== this.state.breakpoint || previousState.trayToggleWidth !== this.state.trayToggleWidth) && this.props.showOpenCaret) {
      this.calcCaretMargin();
    }
  }

  /**
   * Determine left margin for the caret based on the width of the tray-button
   *
   * This causes a potential style reflow, only do this when it is needed to
   * render the button.
   *
   * @api private
   */
  calcCaretMargin() {
    const trayToggleWidth = getWidth(this.trayToggleWrapper.current);
    const caretMarginLeft = trayToggleWidth / 2 - 10;
    this.setState({
      trayToggleWidth,
      caretMarginLeft
    });
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
TrayButton.propTypes = {
  'className': _propTypes.default.string,
  'isOpen': _propTypes.default.bool,
  'ariaLabel': _propTypes.default.string,
  'onClick': _propTypes.default.func.isRequired,
  'children': _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  'traySpanClass': _propTypes.default.string,
  'showOpenCaret': _propTypes.default.bool,
  'dataAttrs': _propTypes.default.object,
  'aria-expanded': _propTypes.default.bool
};
function TrayButtonWrapper(props) {
  const {
    breakpoint
  } = (0, _componentUtilities.useBreakpoints)(...breakpoints);
  return /*#__PURE__*/_react.default.createElement(TrayButton, (0, _extends2.default)({}, props, {
    breakpoint: breakpoint
  }));
}